function Footer() {
  return (
    <footer className="app-footer">
      <small>
        &copy; {new Date().getFullYear()} made by{" "}
        <a
          href="https://techku.id"
          target="_blank"
          rel="noopener noreferrer"
        >
          TechKu
        </a>
      </small>
    </footer>
  );
}

export default Footer;
